import { Form, Input, Modal, notification } from 'antd';
import { viewersApi } from 'api/viewUserApi';
import { activateViewer } from 'models';
import { ViewerInfo } from 'models/viewers';
import * as React from 'react';
import style from './Modal.module.scss';

export interface ActivateViewerProps {
  setIsModalVisible: (value: boolean) => void;
  isModalVisible: boolean;
  itemViewer: ViewerInfo;
  setItemViewer: (value: ViewerInfo) => void;
  setViewerList: (value: ViewerInfo[]) => void;

}

export default function ActivateViewer({
  setItemViewer,
  itemViewer,
  setIsModalVisible,
  isModalVisible,
  setViewerList
}: ActivateViewerProps) {
  const [form] = Form.useForm();
  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const handleOk = async (values: activateViewer) => {
      try {
          await viewersApi.activate({ id: itemViewer.id, password: values.password });
          await setItemViewer({...itemViewer, status: "enabled"})
          const res = await viewersApi.fetchViewers({ _limit: 5, _page: 0 });
          setViewerList(res.data);
          openNotificationWithIcon('success',"Activate viewer successfully")
      } catch (error) {
        openNotificationWithIcon('error',"Activate viewer failed!")
    }

    setIsModalVisible(false);
    form.resetFields();
  };

  return (
    <Modal
      visible={isModalVisible}
      footer={
        <div className={style.footer_modal}>
          <div onClick={handleCancel} className={style.btn_cancel}>
            Cancel
          </div>
          <div onClick={() => form.submit()} className={style.btn_submit}>
            Submit
          </div>
        </div>
      }
      width={720}
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical" onFinish={(values) => handleOk(values)}>
        <Form.Item
          name="password"
          colon={false}
          label="Password"
          labelAlign="left"
          hasFeedback
          rules={[
            { required: true, message: 'Please enter Password' },
            {
              pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/,
              message:
                'Input Password and Submit [8 to 15 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character]',
            },
          ]}
        >
          <Input.Password placeholder="Please enter Password" />
        </Form.Item>
        <Form.Item
          name="password_again"
          colon={false}
          label="New password again"
          labelAlign="left"
          dependencies={['new_password']}
          hasFeedback
          rules={[
            { required: true, message: 'Please enter Password again' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  new Error('The two passwords that you entered do not match!')
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Please enter Password again" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
